<template>
  <div class="kanban-main">
    <dv-full-screen-container>
      <div class="full-bg" ref="kanban">
        <!-- header -->
        <div class="screen-header" style="flex:1">
          <div class="header-cls1">
            <el-popover placement="right" width="250" trigger="click">
              <el-form label-position="left" inline size="mini" ref="teamForm">
                <el-form-item label="看板模式">
                  <el-select style="width:100px;" size="small" v-model="kanbanMode" placeholder="请选择" filterable
                    @change="changeMould">
                    <el-option v-for="(item, index) in ['打分模式', '颁奖模式']" :key="index" :label="item"
                      :value="index"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="参赛组别">
                  <el-select style="width:100px;" size="small" v-model="ctType" placeholder="请选择" filterable
                    @change="changeType">
                    <el-option v-for="item in dict.ct_type" :key="item.value" :label="item.display"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="参赛子组">
                  <el-select style="width:100px;" size="small" v-model="ctSubtype" placeholder="请选择" filterable
                    @change="changeSubtype">
                    <el-option v-for="item in dict.ct_subtype" :key="item.value" :label="item.display"
                      :value="item.index"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="荣获奖项" v-if="kanbanMode == 1">
                  <el-select style="width:100px;" size="small" v-model="ctGrade" placeholder="请选择" filterable
                    @change="changeGrade">
                    <el-option v-for="item in dict.ct_grade" :key="item.value" :label="item.display"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="停滞时长(S)">
                  <el-input-number style="width:100px;" v-model="timeStep" @change="handleChange"
                    :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="参赛阶段">
                  <el-checkbox-group v-model="checkboxGroup" @change="handleCheckedChange">
                    <el-checkbox-button v-for="item in dict.ct_stage" :label="item.value" :key="item.value">{{
                      item.display }}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
                <!-- <div class="zj-form-bottom">
                <el-button size="small" @click="">取&nbsp;&nbsp;消</el-button>
                <el-button type="primary" size="small" @click="" style="margin-left:30px;">保&nbsp;&nbsp;存
                </el-button>
              </div> -->
              </el-form>
              <el-button type="text" slot="reference" icon="el-icon-setting" size="mini"
                style="background-color: #10182c;" circle></el-button>
            </el-popover>
          </div>
          <div class="header-cls2">
            <h2 style="margin: 50px 0 0 0 !important;font-size:45px;color:#fff">{{ competitionTitle }}
            </h2>
          </div>
          <div class="header-cls1">
            <span
              style="padding-top: 50px;font-size:28px;margin-right:10%;font-weight: 500;line-height:28px;display:flex;text-align: center;"></span>
          </div>
        </div>
        <!-- body 上下两个部分-->
        <div style="display: flex;flex-direction: column;flex:9;margin-top: 70px;">
          <div class="zj-flex-column zj-flex-1">
            <dv-border-Box-10 style="flex:1;margin-top:10px;" :color="['rgba(31,167,201,0)', 'rgba(31,167,201,0)']">
              <div class="box-content ">
                <div class="zj-flex-center zj-flex-column" style="width:95%;height:90%;margin:0 auto">
                  <div class="zj-flex-row zj-flex-center">
                    <div class="hand" style="margin-right: 50px;" v-if="ctType != null">{{ dict.ct_type[ctType].display
                      }}</div>
                    <div class="hand" v-if="teamType_id != null">{{ dict.ct_subtype[ctSubtype].display }}</div>
                    <div class="hand" style="margin-left: 50px;" v-if="kanbanMode == 1 & ctGrade != null">{{
                      dict.ct_grade[ctGrade].display }}</div>
                  </div>
                  <dv-scroll-board :config="config"
                    style="width: 90%;height: 100%;margin-bottom: 200px;margin-top: 50px;" />
                </div>
              </div>
            </dv-border-box-10>
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import screenfull from "screenfull";
export default {
  components: {
  },
  props: {
    project_id: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      timeStep: 5,
      cardNum: 0,
      maxCardNum: 0,
      nowInterval: null,
      fontSize_1: this.transformFontSize(100) + 'px',
      config: {
        rowNum: 5,
        header: ['', '', ''],
        data: [['1', '2', '3']],
        align: ['center', 'center', 'center', 'center'],
        waitTime: 5000,
        headerBGC: 'rgba(31,167,201,0)',
        oddRowBGC: 'rgba(31,167,201,0)',
        evenRowBGC: 'rgba(31,167,201,0)',
        hoverPause: false,
        columnWidth: [250, 600, 700, 150],
      },
      ctType: null,
      ctGrade: null,
      ctSubtype: 0,
      teamType_id: null,
      condition: '',
      tableData: [],
      dict: null,
      kanbanMode: 0,
      obFinalResult: 1,
      competitionTitle: null,
      checkboxGroup: [],
      stageList: ""
    }
  },
  methods: {
    toggleFullScreen() {
      if (screenfull.isEnabled) {
        screenfull.toggle();
      } else {
        alert('您的浏览器不支持全屏功能');
      }
    },
    transformFontSize(fontsize) {
      // 获取屏幕宽度
      const width = window.screen.width
      const ratio = width / 1920
      // 取下整
      return parseInt(fontsize * ratio)
    },
    //计时器
    openTimeClock() {
      this.nowInterval = setInterval(() => {
        if (this.maxCardNum == this.cardNum) {
          this.refreshData()
        } else {
          this.changeCard()
          this.cardNum = this.cardNum + 1;
        }
      }, this.timeStep * 1000);
    },
    //清除计时器
    closeTimeClock() {
      clearInterval(this.nowInterval);
    },
    changeCard() {
      let data = []
      let header = []
      let columnWidth = []
      if (this.cardNum < this.tableData.length) {
        let cardData = this.tableData[this.cardNum]
        for (var i = 0; i < cardData.length; i++) {
          if (this.kanbanMode == 0) {
            header = ['队伍编号', '所属单位', '作品名称', '最终分数']
            columnWidth = [300, 800, 700, 300]
            if (cardData[i].ct_finalresult == null) {
              cardData[i].ct_finalresult = '-'
            }
            data.push([cardData[i].ct_code, cardData[i].ct_belong, cardData[i].cw_name, cardData[i].ct_finalresult])
          } else {
            header = ['', '', '']
            columnWidth = [300, 800, 700]
            data.push([cardData[i].ct_code, cardData[i].ct_belong, cardData[i].cw_name])
          }
        }
      }
      this.config.header = header;
      this.config.data = data;
      this.config.columnWidth = columnWidth;
      this.config = { ...this.config }; //必不可少，不可省略
    },
    //切割列表
    chunkArray(data) {
      this.maxCardNum = Math.ceil(data.length / this.config.rowNum);
      let chunks = [];
      for (let i = 0; i < data.length; i += this.config.rowNum) {
        chunks.push(data.slice(i, i + this.config.rowNum));
      }
      this.tableData = chunks;
      console.log(this.tableData, 'tableData')
      this.changeCard()
    },
    refreshData() {
      this.tableData = []
      this.cardNum = 0
      this.z_get(
        "api/competition_team/getTeamKanban", { condition: this.condition, projectid: this.project_id, ct_type: this.ctType, ct_subtype: this.teamType_id, ct_grade: this.ctGrade, obFinalResult: this.obFinalResult, stageList: this.stageList }
      )
        .then(res => {
          if (res.data.length > 0) {
            this.competitionTitle = res.data[0].p_name
          }
          console.log(res.data, 'res.data')
          if (this.dict == null) {
            this.getsubTypeList(res.dict)
          }
          this.chunkArray(res.data)
        })
        .catch(res => { });
    },
    getsubTypeList(dict) {
      dict["ct_subtype"] = []
      this.z_get("api/competition_team_type/getProjectTeamType", { project_id: this.project_id })
        .then(res => {
          let n = 0
          dict.ct_subtype.push({ index: n, value: null, display: '所有子组' })
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].type_size == 1) {
              n = n + 1
              dict["ct_subtype"].push({ index: n, value: res.data[i].competition_team_type_id, display: res.data[i].type_name })
            }
          }
          dict.ct_grade.push({ value: null, display: '所有奖项' })
          dict.ct_type.push({ value: null, display: '所有组别' })
          this.checkboxGroup = []
          for (var i = 0; i < dict.ct_stage.length; i++) {
            this.checkboxGroup.push(dict.ct_stage[i].value)
          }
          this.dict = dict
        }
        )
        .catch(res => {
        })
    },
    changeType() {
      this.ctSubtype = 0
      this.teamType_id = null
      this.refreshData()
    },
    changeSubtype() {
      this.teamType_id = this.dict.ct_subtype[this.ctSubtype].value
      this.refreshData()
    },
    changeGrade() {
      this.refreshData()
    },
    changeMould() {
      this.ctGrade = null
      this.refreshData()
    },
    handleChange() {
      this.closeTimeClock()
      this.openTimeClock()
    },
    handleCheckedChange() {
      console.log(this.checkboxGroup)
      if (this.checkboxGroup.length > 0) {
        this.stageList = JSON.stringify(this.checkboxGroup)
        this.refreshData()
      } else {
        this.tableData = []
        this.config.data = []
        this.config = { ...this.config }; //必不可少，不可省略
      }


    }
  },
  mounted() {
    //this.project_id = this.$route.query.project_id
    this.refreshData()
    this.openTimeClock();
  },
  destroyed() {
    this.closeTimeClock();
  },

}

</script>

<style scoped>
.kanban-main {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.full-bg {
  background: url("/static/base/img/competitionBG.jpeg") no-repeat;
  /* background: #10182c; */
  background-size: 100% 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
}

.screen-header {
  display: flex;
  flex-direction: row;
  height: 80px;
}

.header-cls1 {
  color: #fff;
  width: 5%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header-cls2 {
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: rgb(135, 155, 173);
}

.card-cls {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
}

.hand {
  font-size: 43px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: rgb(255, 255, 255);
}

.img {
  width: 60px;
  height: 60px;
  padding-top: 20px;
  line-height: 35px;
}

::v-deep .dv-scroll-board .header-item {
  font-size: 35px;
  font-weight: 600;
  color: #85aeff;
}

::v-deep .dv-scroll-board .rows .row-item {
  font-size: 30px;
  font-weight: 600;
}

::v-deep .dv-scroll-board .rows .ceil {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.box-content {
  display: flex;
  /* flex: 1; */
  height: 100%;
  /* background: #ffffff; */
  flex-direction: column;
}
</style>
